import { OnInit } from '@angular/core';
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { HtmlBase, BObjectModel, PropertyData, QueovalItemModel, QueovalItem } from '../../../../../models';
import { CoreService, HttpService } from '../../../../../services';
import { ToastService } from '../../../../../toast';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-cycle-elearning',
  templateUrl: './cycle-elearning.component.html',
  styleUrls: ['./cycle-elearning.component.css', '../../../dynamictag.component.css']

})

export class CycleElearningComponent implements OnInit {

  // #region VARIABLES GLOBALES

  // #region public
  public dateExpiration: Date | null;
  public displayModeAjoutUniquement: boolean = true;
  public valueModeAjoutUniquement: boolean = true;

  public cyclesEl: Array<QueovalItem> = [];
  public stagiaires: Array<QueovalItem> = [];

  public idUser: string = '0';
  public idStage: string = '0';
  // #endregion

  // #region private

  // #endregion

  // #endregion

  // #region DIRECTIVES
  @Input('idUser') set SetIdUser(value: string) {
    if (value)
      this.idUser = value
  }
  @Input('idStage') set SetIdStage(value: string) {
    if (value)
      this.idStage = value
  }

  @Output('save') save: EventEmitter<void> = new EventEmitter<void>(false);
  //   // #endregion

  // #region CONSTRUCTEUR
  constructor(
    private toastservice: ToastService,
    private indParam: CoreService,
    private http: HttpService,
  ) { }
  //   // #endregion

  log(e: any): void {
    console.log(e);
  }

  // #region FONCTIONS PUBLIQUES
  public ngOnInit(): void {
    if (this.idStage == '0') {
      this.http.getHttp<QueovalItemModel>(`${this.indParam.AppParams.apiUrl}api/queovalitem/getData/DATE_EXPIRATION_STAGE/${this.idUser}`).subscribe(
        (result: QueovalItemModel) => {
          this.dateExpiration = result.Date;
        })
    }

    if (this.idUser != '0') {
      this.displayModeAjoutUniquement = false;
      this.http.getHttp<QueovalItemModel>(`${this.indParam.AppParams.apiUrl}api/queovalitem/getData/LISTE_CYCLES_EL_PAR_APPERNANT/${this.idUser}`).subscribe(
        (result: QueovalItemModel) => {
          this.cyclesEl = result.queovalItemList;
        });
    } else if (this.idStage != '0') {
      this.http.getHttp<QueovalItemModel>(`${this.indParam.AppParams.apiUrl}api/queovalitem/getData/LISTE_CYCLES_EL_PAR_STAGE/${this.idStage}`).subscribe(
        (result: QueovalItemModel) => {
          this.cyclesEl = result.queovalItemList;
        })
      this.http.getHttp<QueovalItemModel>(`${this.indParam.AppParams.apiUrl}api/queovalitem/getData/LISTE_APPERNANT_PAR_STAGE/${this.idStage}`).subscribe(
        (result: QueovalItemModel) => {
          this.stagiaires = result.queovalItemList;
        })
    }
  }

  public OnSave(): void {
    const model: QueovalItemModel = new QueovalItemModel();
    model.Mode = 'AFFECT_CYCLE_EL_TO_USER';
    model.queovalItemList = this.cyclesEl.filter(cycle => cycle.Selected);
    model.Boolean = this.displayModeAjoutUniquement && this.valueModeAjoutUniquement;
    model.Boolean2 = false;
    model.Date = this.dateExpiration as Date;
    this.indParam.showSplash(true);
    if (this.idUser != '0') {
      model.Ident = this.idUser;
      this.http.postHttp<QueovalItemModel>(`${this.indParam.AppParams.apiUrl}api/queovalitem`, model).subscribe(
        () => {
          this.indParam.showSplash(false);
          this.save.emit();
        }
      );
    }
    else if (this.idStage != '0') {
      model.Boolean2 = true;
      this.stagiaires.forEach(stagiaire => {
        model.Ident = stagiaire.Value;
        this.http.postHttp<QueovalItemModel>(`${this.indParam.AppParams.apiUrl}api/queovalitem`, model).subscribe(
          () => {
            this.indParam.showSplash(false);
            this.save.emit();
          }
        );
      })
    } else {
      this.indParam.showSplash(false);
    }
  }
  // #endregion

  // #region FONCTIONS PRIVEES
  
  // #endregion
}

